import * as React from "react"
import { useToggleGatsbyjsioEnabled } from "../hooks/useToggleGatsbjsio"
import {
  siteBuildsSettings as text,
  ui as uiText,
} from "@modules/locales/default.js"
import { Spacer, ToggleCheckbox, Badge, Link } from "gatsby-interface"
import { MdInfoOutline } from "react-icons/md"

export type EnableGatsbyjsioProps = {
  siteId: string
  organizationId: string
  enabled: boolean
}

export function EnableGatsbyjsio({ siteId, enabled }: EnableGatsbyjsioProps) {
  const [toggleGatsbyjsioEnabled, { errorAlert }] =
    useToggleGatsbyjsioEnabled(siteId)

  const readMoreLink = `https://gatsby.dev/unified-hosting`

  return (
    <React.Fragment>
      <ToggleCheckbox
        id="enable-gatsbyjsio-checkbox"
        label={
          <React.Fragment>
            {text.labels.enableGatsbjsio}
            <Spacer direction="horizontal" size={3} />
            <Link href={readMoreLink}>
              <MdInfoOutline />
            </Link>
            <Spacer direction="horizontal" size={3} />
            <Badge tone="SUCCESS" size="S" textVariant="DEFAULT">
              {uiText.labels.beta}
            </Badge>
          </React.Fragment>
        }
        hint={<React.Fragment>{text.messages.enableGatsbjsio}</React.Fragment>}
        checked={!!enabled}
        onChange={() => {
          toggleGatsbyjsioEnabled()
        }}
      />
      {errorAlert}
    </React.Fragment>
  )
}
